export function toEventOrPartner(auth:Auth) {
    let result = 'event'
    if(auth.data && auth.data.m_oPartner.m_sUrl){ result = auth.data.m_oPartner.m_sUrl}
    return result
}